import { RESET_APP } from '../actions';
import {
  RECEIVE_DISCOUNTS, SELECT_DISCOUNT, REMOVE_PROMO, RESET_DISCOUNTS
} from '../actions/discount';

const initialState = {
  discountsData: null,
  selectedDiscountId: '0',
  selectedDiscountAmtSaved: 0,
  selectedPromoCode: '',
  forcePromoCode: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_DISCOUNTS:
      return {
        ...state,
        discountsData: action.discounts
      };
    case SELECT_DISCOUNT:
      return {
        ...state,
        selectedDiscountId: action.discount.id,
        selectedDiscountAmtSaved: action.discount.total,
        isPromoDiscount: action.discount.isPromoDiscount ? true : false,
        selectedPromoCode: action.discount.isPromoDiscount ? action.discount.promo : '',
        forcePromoCode: action.discount.forcePromo ? true : false
      };
    case RESET_DISCOUNTS:
      return { ...initialState };
    case REMOVE_PROMO:
      return {
        ...state,
        isPromoDiscount: false,
        selectedPromoCode: '',
        forcePromoCode: false
      };
    case RESET_APP:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
